<template>
  <!-- prettier-ignore -->
  <svg aria-hidden="true" focusable="false" width="12" height="12" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg"><polygon points="12 0.705882353 6.70588235 6 12 11.2941176 11.2941176 12 6 6.70588235 0.705882353 12 0 11.2941176 5.29411765 6 0 0.705882353 0.705882353 0 6 5.29411765 11.2941176 0" fill="currentColor" fill-rule="evenodd"/></svg>
</template>
